const currentOrigin = (subdomain?: string) => {
  const url = new URL(window.location.href);

  if (subdomain !== undefined) {
    if (url.hostname.includes('tunnel.teemill.com')) {
      url.hostname = `${subdomain}-${url.hostname}`;
    } else {
      url.hostname = `${subdomain}.${url.hostname}`;
    }
  }

  return url.origin;
};

export const apiBasePath = (): string => {
  if (import.meta.env.VITE_API_PROXY === 'true') {
    return currentOrigin();
  }

  return import.meta.env.VITE_API_SERVICE_URL;
};

export const eventsBasePath = (): string => {
  if (import.meta.env.VITE_API_PROXY === 'true') {
    return currentOrigin().replace(/^[^:]+:\/\//, 'ws://') + '/ws';
  }

  return import.meta.env.VITE_EVENTS_SERVICE_URL;
};

export const coreApiBasePath = (): string => {
  if (import.meta.env.VITE_CORE_API_PROXY === 'true') {
    return currentOrigin();
  }

  return import.meta.env.VITE_CORE_API_SERVICE_URL;
};
